export class replenishmentCreate { 
    public name: string;
    public fromInventoryStatus: string;
    public toInventoryStatus: string;
    public maxLinesOrTransfer: number;
    public autoRun: boolean;
    public transferDate: string;
    public customField1: string;
    public customField2: string;
    constructor() {
        this.name = "";
        this.fromInventoryStatus = "";
        this.toInventoryStatus = "";
        this.maxLinesOrTransfer = 0;
        this.autoRun = true;
        this.transferDate = "2024-11-07";
        this.customField1 = "";
        this.customField2 = "";
    }
}